import { createContext, useContext } from 'react';
import type { ColorSchemePreference } from '@moko/utils';

export type ColorSchemeContextValue = {
  colorScheme: ColorSchemePreference;
  saving: boolean;
  error: string | null;
  setColorScheme: (colorScheme: ColorSchemePreference) => void;
};

export const ColorSchemeContext = createContext<ColorSchemeContextValue | null>(
  null
);

export const useColorScheme = (): ColorSchemeContextValue => {
  const value = useContext(ColorSchemeContext);
  if (!value) {
    throw new Error('useColorScheme must be used within a MokoThemeProvider');
  }
  return value;
};
